function intersectOrder(left, right) {
	const common = new Set(left.filter(k => right.includes(k)));
	const leftCommon = left.filter(k => common.has(k));
	const rightCommon = right.filter(k => common.has(k));
	const changed = JSON.stringify(leftCommon) !== JSON.stringify(rightCommon);
	return changed ? { before: leftCommon, after: rightCommon } : null;
}

/**
 * Compare the ordering of ONLY the keys common to both schemas, so adding or
 * removing a field (reported under Fields) does not also register as a field-
 * order change. Returns null when the common-key order is unchanged.
 */
export function diffFieldOrderForCompare(leftSchema, rightSchema) {
	const left = leftSchema || {};
	const right = rightSchema || {};

	const properties = intersectOrder(
		Object.keys(left.properties || {}),
		Object.keys(right.properties || {}),
	);
	const required = intersectOrder(
		Array.isArray(left.required) ? left.required : [],
		Array.isArray(right.required) ? right.required : [],
	);

	if (properties === null && required === null) return null;
	return { properties, required };
}
